// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xka1hU6V02qIVh {
  display: flex;
  padding: var(--ds-space-100, 8px);
}
.xka1hU6V02qIVh span {
  min-width: 20px;
  margin-right: var(--ds-space-050, 4px);
}
.xka1hU6V02qIVh p {
  margin: var(--ds-space-0, 0);
}
.uzqpPz3uidX2aQ {
  font-size: 11px;
  line-height: 14px;
}
.HBZ5cssywVJfYl {
  font-size: 12px;
}
.F0C3k_ObA3ccSK {
  margin-top: var(--ds-space-100, 8px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mirrorCardAccessRestricted": `xka1hU6V02qIVh`,
	"content": `uzqpPz3uidX2aQ`,
	"message": `HBZ5cssywVJfYl`,
	"requestAccessButton": `F0C3k_ObA3ccSK`
};
export default ___CSS_LOADER_EXPORT___;
